import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Initialize Firebase
const app = initializeApp(JSON.parse(process.env.FIREBASE_CONFIG));

export const auth = getAuth(app);
export const db = getFirestore(app);
